import React, { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';
import { invitationTemplates } from '../wizard/data';

const slides = invitationTemplates.map((template) => ({
  src: `/template-previews/${template.style}.jpg`,
  alt: `${template.name}邀請函範本`,
}));

interface HeroPhoneShowcaseProps {
  className?: string;
}

export const HeroPhoneShowcase: React.FC<HeroPhoneShowcaseProps> = ({ className }) => {
  const [active, setActive] = useState(0);
  const [autoplay, setAutoplay] = useState(true);

  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (media.matches) {
      setAutoplay(false);
      return;
    }
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % slides.length);
    }, 3500);
    return () => window.clearInterval(timer);
  }, []);

  const shown = autoplay ? active : 0;

  return (
    <div className={cn('relative mx-auto w-[230px] sm:w-[280px]', className)}>
      <div
        className="pointer-events-none absolute -inset-6 rounded-[3rem] bg-gradient-to-tr from-wedding-pink/30 via-rose-300/25 to-amber-200/30 blur-2xl"
        aria-hidden="true"
      />
      <div className="relative aspect-[9/19] overflow-hidden rounded-[2.25rem] border-4 border-gray-900 bg-gray-900 ring-1 ring-black/10 shadow-[0_25px_60px_-15px_rgba(190,24,93,0.3)]">
        {slides.map((slide, index) => (
          <img
            key={slide.src}
            src={slide.src}
            alt={slide.alt}
            loading={index === 0 ? undefined : 'lazy'}
            className={cn(
              'absolute inset-0 h-full w-full object-cover object-top motion-safe:transition-opacity motion-safe:duration-1000',
              index === shown ? 'opacity-100' : 'opacity-0'
            )}
          />
        ))}
      </div>
    </div>
  );
};
